import { message } from 'antd';
import { RcFile } from 'antd/lib/upload';

export const isFileSizeLess = (file: RcFile, maxSizeMB = 10): boolean => {
  const fileSizeInMB = file.size / (1024 * 1024);

  if (fileSizeInMB < maxSizeMB) {
    return true;
  }

  message.error(
    `O arquivo deve ter no máximo ${maxSizeMB}MB. Tamanho atual: ${fileSizeInMB.toFixed(
      2
    )}MB.`
  );
  return false;
};
